import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { User, Country, States, Cities } from "../_models/index";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";

@Injectable()
export class UserService {
  public getSignUpData;
  constructor(private http: HttpClient, private router: Router) {}

  /**getAll() {
    return this.http.get<User[]>('/api/users');
  }

  getById(id: number) {
    return this.http.get('/api/users/' + id);
  }*/

  create(user: User) {
    user.device_type = 1;
    user.device_token = "";
    user.payment_platform_id = "";
    user.payment_platform_type_id = "";
    user.status = 1;

    return this.http
      .post<any>(environment.apiUrl + "user/register", user)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  update(user: User) {
    return this.http.put("/api/users/" + user.id, user);
  }

  delete(id: number) {
    return this.http.delete("/api/users/" + id);
  }

  getAllCountry() {
    return this.http.get<any>(environment.apiUrl + "countries").map((data) => {
      if (data.status === 200) {
        return data.result;
      } else {
        return [];
      }
    });
  }

  getAllStates(c_id) {
    return this.http
      .get<any>(environment.apiUrl + "states/" + c_id)
      .map((data) => {
        if (data.status === 200 || data.code === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  getAllCities(c_id) {
    return this.http
      .get<any>(environment.apiUrl + "cities/" + c_id)
      .map((data) => {
        if (data.status === 200 || data.code === 200) {
          return data.result;
        } else {
          return [];
        }
      });
  }

  getUserByEmail(email) {
    return this.http
      .get<any>(environment.apiUrl + "email/" + email)
      .map((data) => {
        if (data) {
          return data;
        }

        return [];
      });
  }

  getUserByUsername(username) {
    return this.http
      .get<any>(environment.apiUrl + "username/" + username)
      .map((data) => {
        if (data) {
          return data;
        }

        return [];
      });
  }

  updateUserAccount(user) {
    return this.http
      .post<any>(environment.apiUrl + "user/updateProfile", user)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  updatePassword(passwordData) {
    return this.http
      .post<any>(environment.apiUrl + "user/changePassword", passwordData)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return data;
        }
      });
  }

  getstripeinfo(adData) {
    adData.code ? adData.code : null;
    adData.state ? adData.state : null;
    adData.scope ? adData.scope : null;
    return this.http
      .post<any>(environment.apiUrl + "redirect_from_stripe", adData)
      .map((data) => {
        if (data.status === 200) {
          return data;
        } else {
          return [];
        }
      });
  }

  imageUpload(event: EventTarget) {
    let headers = new HttpHeaders();
    headers.set("Accept", "application/json");
    headers.append("Content-Type", "multipart/form-data");

    const eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    const target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    const files: FileList = target.files;
    const formData: FormData = new FormData();
    formData.append("file", files[0]);

    // POST
    return this.http
      .post<any>(`${environment.apiUrl}user/profileImage`, formData, {
        headers,
      })
      .map((res: Response) => {
        return res;
      });
  }

  getTermsServiceData(data): any {
    if (this.router.url == "/register") {
      this.getSignUpData = data;
    } else {
      this.getSignUpData = "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/user.service.ts